import component from "./DragDropContainer";

export default component;
